(() => {
  let pending = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const update = async (input, quantity) => {
    const drawer = input.closest('[data-native-cart]');
    const key = input.closest('[data-line-key]')?.dataset.lineKey;
    if (pending || !key || !Number.isInteger(quantity) || quantity < 0) return;
    pending = true;
    drawer.setAttribute('aria-busy', 'true');
    drawer.querySelectorAll('button,input').forEach(el => el.disabled = true);
    const scroll = drawer.querySelector('.eo-cart__scroll')?.scrollTop || 0;
    const focusStep = input.dataset.eoStep;
    const header = document.querySelector('[data-header-section]');
    const section = header.dataset.headerSection;
    try {
      const response = await fetch(root() + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({id:key, quantity, sections:[section], sections_url:location.pathname})});
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message);
      let html = cart.sections?.[section];
      if (!html) {
        const refresh = new URL(location.href);
        refresh.searchParams.set('section_id', section);
        const result = await fetch(refresh);
        if (!result.ok) throw new Error();
        html = await result.text();
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-native-cart]');
      if (!next) throw new Error();
      drawer.innerHTML = next.innerHTML;
      const scroller = drawer.querySelector('.eo-cart__scroll');
      if (scroller) scroller.scrollTop = scroll;
      document.querySelectorAll('.cart-link__count').forEach(el => el.textContent = cart.item_count);
      const line = [...drawer.querySelectorAll('[data-line-key]')].find(el => el.dataset.lineKey === key);
      const target = focusStep ? line?.querySelector(`[data-eo-step="${focusStep}"]`) : line?.querySelector('[data-eo-quantity]');
      (target || drawer.querySelector('[data-dialog-close]')).focus({preventScroll:true});
    } catch (error) {
      const box = drawer.querySelector('.eo-cart__error');
      if (box) {box.hidden = false; box.textContent = error.message || drawer.dataset.error;}
    } finally {
      pending = false;
      drawer.removeAttribute('aria-busy');
      drawer.querySelectorAll('button,input').forEach(el => el.disabled = false);
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-eo-step],[data-eo-remove]');
    if (!button) return;
    event.preventDefault();
    const quantity = Number(button.closest('[data-line-key]').querySelector('[data-eo-quantity]').value);
    update(button, button.hasAttribute('data-eo-remove') ? 0 : Math.max(0, quantity + Number(button.dataset.eoStep)));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-eo-quantity]')) update(event.target, Number(event.target.value));
  });
})();
